import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import template from './index.jade';
import css from './shadow.inline.styl';
import './index.styl';

export interface AuthContainerJsxProps {
  attrs?: {
    'show-footer-links'?: boolean;
    'hide-header'?: boolean;
  };
}

export class AuthContainer extends Component<EmptyObj, AuthContainerJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<AuthContainerJsxProps['attrs']> {
    return {
      'show-footer-links': `boolean`,
      'hide-header': `boolean`,
    };
  }
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
    };
  }
}

export const AuthContainerEl = defineAndMakeJsxFactory<AuthContainerJsxProps>(`auth-container`, AuthContainer);
export const AuthContainerReact = panel2react<AuthContainerJsxProps>(`auth-container`, AuthContainer);
